import { render, staticRenderFns } from "./mailInfo.vue?vue&type=template&id=fd73d5ea"
import script from "./mailInfo.vue?vue&type=script&lang=js"
export * from "./mailInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd73d5ea')) {
      api.createRecord('fd73d5ea', component.options)
    } else {
      api.reload('fd73d5ea', component.options)
    }
    module.hot.accept("./mailInfo.vue?vue&type=template&id=fd73d5ea", function () {
      api.rerender('fd73d5ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerRecordManage/recordFrom/mailInfo.vue"
export default component.exports